// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

// Images
import ecoIcon from '@src/data/images/2e-ecobrand-icon.png';
import globeIcon from '@src/data/images/2e-globe-icon.png';
import supportIcon from '@src/data/images/2e-support-icon.png';

// Styles
import styles from './styles.module.css';

const SustainabilityPriority: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS}>Sustainability Goes From Perk to Priority</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-12">
        <div className="col-span-2">
          <div className={styles.graphic}>
            <h2 {...DEFAULT_SAL_PROPS} data-sal-delay={SAL_DELAY * 5}>
              Nearly 2.5X more consumers plan to shift their spend to
              sustainable brands.
            </h2>
            <div
              data-sal="fade"
              data-sal-delay={SAL_DELAY * 1}
              data-sal-duration={2000}
            >
              <Image alt="Woman with plants" fileName="2e-chart.jpg" />
            </div>
          </div>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 5}
            className="tup-description"
          >
            Percentage of consumers who say they will spend more on sustainable
            brands within the next 5 years<sup>2</sup>
          </p>
        </div>
        <div {...DEFAULT_SAL_PROPS} className="mt-8 md:mt-0">
          <h2
            {...DEFAULT_SAL_PROPS}
            data-sal="fade"
            data-sal-delay={SAL_DELAY * 1}
            className="text-center"
          >
            Will Covid spark a more sustainable fashion future?
          </h2>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 2}
            className="grid grid-cols-3 gap-4 mb-12 mt-8"
          >
            <img alt="Globe Icon" className="m-auto" src={globeIcon} />
            <p className="col-span-2 pr-8">
              <b>70%</b> of all consumers agree that addressing climate change
              is more important now than ever.<sup>3</sup>
            </p>
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 3}
            className="grid grid-cols-3 gap-4 mb-12 mt-8"
          >
            <img alt="Eco Brand Icon" className="m-auto" src={ecoIcon} />
            <p className="col-span-2 pr-6">
              Eco-brands like Patagonia and Allbirds are getting <b>57%</b> more
              interest on thredUP since Covid.<sup>8</sup>
            </p>
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 4}
            className="grid grid-cols-3 gap-4 mb-12 mt-8"
          >
            <img alt="Support Icon" className="m-auto" src={supportIcon} />
            <p className="col-span-2 pr-4">
              <b>73%</b> of people plan to support brands who contributed
              positively to those in need during Covid.<sup>3</sup>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SustainabilityPriority };
